/**
 * @generated SignedSource<<43bd1ddde52bfebcf75423782a6696aa>>
 * @relayHash ec4d8643ad14f845c672ac02c6477a9a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 294306842461964d576126c1a580088f0f38450c95ffee72c5dfabba4e5cd9f3

import type { ConcreteRequest } from 'relay-runtime';
export type PageActivityAction = "created" | "published" | "snapshotted" | "started" | "updated" | "%future added value";
export type PageActivityActionSubject = "comment" | "page" | "%future added value";
export type AllActivityDropdownFeedCardAllActivityQuery$variables = {
  after?: string | null | undefined;
  contentId: string;
  fromDate?: string | null | undefined;
};
export type AllActivityDropdownFeedCardAllActivityQuery$data = {
  readonly pageActivity: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "PageActivityEventStartedPage";
      readonly action: PageActivityAction;
      readonly actionSubject: PageActivityActionSubject;
      readonly comment?: {
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        };
      } | null | undefined;
      readonly groupSize?: number;
      readonly pageVersion?: number;
      readonly timestamp: string;
      readonly user?: {
        readonly __typename: "AtlassianUser";
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined>;
    readonly pageInfo: {
      readonly endCursor: string;
      readonly hasNextPage: boolean;
    };
  } | null | undefined;
};
export type AllActivityDropdownFeedCardAllActivityQuery = {
  response: AllActivityDropdownFeedCardAllActivityQuery$data;
  variables: AllActivityDropdownFeedCardAllActivityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromDate"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "contentId",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "fromDate",
    "variableName": "fromDate"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "timestamp"
},
v5 = {
  "kind": "ScalarField",
  "name": "action"
},
v6 = {
  "kind": "ScalarField",
  "name": "actionSubject"
},
v7 = {
  "kind": "ScalarField",
  "name": "groupSize"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    {
      "kind": "ScalarField",
      "name": "isPrimary"
    }
  ]
},
v11 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ]
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    (v11/*: any*/)
  ],
  "type": "PageActivityEventCreatedPage"
},
v13 = {
  "kind": "ScalarField",
  "name": "pageVersion"
},
v14 = {
  "kind": "InlineFragment",
  "selections": [
    (v13/*: any*/),
    (v7/*: any*/),
    (v11/*: any*/)
  ],
  "type": "PageActivityEventUpdatedPage"
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    {
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "comment",
      "plural": false,
      "selections": [
        (v8/*: any*/),
        {
          "concreteType": "Map_LinkType_String",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "webui"
            }
          ]
        }
      ]
    },
    (v11/*: any*/)
  ],
  "type": "PageActivityEventCreatedComment"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v16/*: any*/)
  ]
},
v18 = [
  (v13/*: any*/),
  (v7/*: any*/),
  (v17/*: any*/),
  (v16/*: any*/)
],
v19 = {
  "concreteType": "PageActivityPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v20 = [
  (v13/*: any*/),
  (v7/*: any*/),
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "AllActivityDropdownFeedCardAllActivityQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedPageActivity",
        "kind": "LinkedField",
        "name": "pageActivity",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v18/*: any*/),
                "type": "PageActivityEventStartedPage"
              },
              {
                "kind": "InlineFragment",
                "selections": (v18/*: any*/),
                "type": "PageActivityEventSnapshottedPage"
              },
              {
                "kind": "InlineFragment",
                "selections": (v18/*: any*/),
                "type": "PageActivityEventPublishedPage"
              }
            ]
          },
          (v19/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AllActivityDropdownFeedCardAllActivityQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "PaginatedPageActivity",
        "kind": "LinkedField",
        "name": "pageActivity",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v20/*: any*/),
                "type": "PageActivityEventStartedPage"
              },
              {
                "kind": "InlineFragment",
                "selections": (v20/*: any*/),
                "type": "PageActivityEventSnapshottedPage"
              },
              {
                "kind": "InlineFragment",
                "selections": (v20/*: any*/),
                "type": "PageActivityEventPublishedPage"
              }
            ]
          },
          (v19/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "ec4d8643ad14f845c672ac02c6477a9a",
    "id": "294306842461964d576126c1a580088f0f38450c95ffee72c5dfabba4e5cd9f3",
    "metadata": {},
    "name": "AllActivityDropdownFeedCardAllActivityQuery",
    "operationKind": "query",
    "text": "query AllActivityDropdownFeedCardAllActivityQuery($contentId:ID!,$after:String,$fromDate:String){pageActivity(contentId:$contentId,after:$after,fromDate:$fromDate){nodes{__typename,timestamp,action,actionSubject,...on PageActivityEventCreatedPage{groupSize,user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventUpdatedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventCreatedComment{groupSize,comment{id,links{webui}},user{id,displayName,photos{value,isPrimary}}},...on PageActivityEventStartedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename},...on PageActivityEventSnapshottedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename},...on PageActivityEventPublishedPage{pageVersion,groupSize,user{id,displayName,photos{value,isPrimary},__typename},__typename}},pageInfo{endCursor,hasNextPage}}}"
  }
};
})();

(node as any).hash = "ece1744e2c59bb61b408ccc9b612626e";

export default node;
